import { Pipe, PipeTransform } from '@angular/core';

import { WrappedValueOpts, wrapValue } from '../mailgun/wrap-value';

@Pipe({
  name: 'mailgunWrapVariable',
  standalone: true,
})
export class MailgunWrapVariablePipe implements PipeTransform {
  public transform(value: any, key: string, opts: WrappedValueOpts): any {
    return wrapValue(key, value, opts);
  }
}
